export const CALL_CARD_PRIORITY_OPTIONS: Array<{ value: number; label: string }> = [
  { value: 5, label: '5' },
  { value: 4, label: '4' },
  { value: 3, label: '3' },
  { value: 2, label: '2' },
  { value: 1, label: '1' },
];

export const NOC_PRIORITY_OPTIONS: Array<{ value: number | null; label: string }> = [
  { value: null, label: 'None' },
  { value: 1, label: '1' },
  { value: 2, label: '2' },
  { value: 3, label: '3' },
  { value: 4, label: '4' },
  { value: 5, label: '5' },
];

export const DEFAULT_CALL_CARD_PRIORITY = 5;
